<template>
  <div class="dealers-view">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C"/>
    </template>
    <template v-else>
      
      <inner-navigation>
        <router-link to="/dealers/all">Все дилеры</router-link>
        <router-link to="/dealers/deleted">Удаленные</router-link>
        <router-link to="/dealers/cities">Города</router-link>
      </inner-navigation>

      <component
        :is="tableType"
        :tableOptions="tableOptions"
        @changeOrder="changeOrder"
        @changePage="changePage"
        @rowClick="openItem"
      />

    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';

import * as tables from '@/components/sections/dealers/tables';

export default {
  name: 'dealers-view',

  components: {
    TableElement,
    ...tables,
  },

  props: {
    showDeleted: Boolean,
  },

  watch: {
    $route() {
      this.changeParams({ only_deleted: this.$route.meta.showDeleted }, true);
    },

    params: {
      deep: true,
      handler: function() {
        this.fetch();
      },
    },
  },

  computed: {
    ...mapGetters({
      loading: 'dealers/loading',
      params: 'dealers/params',
      error: 'dealers/error',
      list: 'dealers/list',
    }),

    tableOptions() {
      return {
        list: this.list,

        order: this.params.order,
      };
    },

    tableType() {
      return this.$route.meta.tableType;
    },
  },

  methods: {
    ...mapActions({
      changeParams: 'dealers/changeParams',
      fetch: 'dealers/fetch',
    }),

    changeOrder(column) {
      const currentOrder = this.params.order;
      const desc = currentOrder.column === column ? !currentOrder.desc : true;

      this.changeParams({
        order: {
          column,
          desc,
        },
      });
    },

    changePage(skip) {
      this.changeParams({
        skip,
      });
    },

    openItem(id) {
      this.$router.push({
        name: 'dealers-item',
        params: {
          id,
        },
      });
    },
  },

  beforeMount() {
    this.changeParams({ only_deleted: this.$route.meta.showDeleted }, true);
    this.fetch();
  },
};
</script>

<style lang="scss" scoped>
.dealers-view {
  position: relative;
  min-height: 100%;
}
</style>
